import React from 'react';

import AppointmentIcon from '../../../assets/svgComponents/LeftNavigationIcons/AppointmentIcon';
import CustomLinkIcon from '../../../assets/svgComponents/LeftNavigationIcons/CustomLinkIcon';
import MessengerIcon from '../../../assets/svgComponents/LeftNavigationIcons/MessengerIcon';
import PhoneIcon from '../../../assets/svgComponents/LeftNavigationIcons/PhoneIcon';
import VideoChatIcon from '../../../assets/svgComponents/LeftNavigationIcons/VideoChatIcon';
import WhatsAppIcon from '../../../assets/svgComponents/LeftNavigationIcons/WhatsAppIcon';
import ParticipantChatNameComponent from '../participantChatNameComponent';

import VIDABOO_CONSTANTS from '../../../config/consts';

import './chatEventIconComponent.css';

const ChatEventIconComponent = ({
  eventType,
  formattedDate,
  participantName,
  handleClick = () => {},
}) => {
  const getIconFromEventType = () => {
    VideoChatIcon;
    switch (eventType) {
      case VIDABOO_CONSTANTS.CHAT_SUBTYPES.VIDEOCHAT_MESSAGE:
        return <VideoChatIcon fillColor="#2961fa" />;
      case VIDABOO_CONSTANTS.CHAT_SUBTYPES.SCHEDULE_MEETING:
        return <AppointmentIcon fillColor="#2961fa" />;
      case VIDABOO_CONSTANTS.CHAT_SUBTYPES.MESSENGER_MESSAGE:
        return <MessengerIcon fillColor="#2961fa" />;
      case VIDABOO_CONSTANTS.CHAT_SUBTYPES.WHATSAPP_MESSAGE:
        return <WhatsAppIcon fillColor="#2961fa" />;
      case VIDABOO_CONSTANTS.CHAT_SUBTYPES.PHONE_MESSAGE:
        return <PhoneIcon fillColor="#2961fa" />;
      case VIDABOO_CONSTANTS.CHAT_SUBTYPES.CUSTOM_LINK_MESSAGE:
        return <CustomLinkIcon fillColor="#2961fa" />;
      default:
        return VideoChatIcon;
    }
  };
  const getIconFromEventText = () => {
    switch (eventType) {
      case VIDABOO_CONSTANTS.CHAT_SUBTYPES.VIDEOCHAT_MESSAGE:
        return 'Video Chat';
      case VIDABOO_CONSTANTS.CHAT_SUBTYPES.SCHEDULE_MEETING:
        return 'Appointment';
      case VIDABOO_CONSTANTS.CHAT_SUBTYPES.MESSENGER_MESSAGE:
        return 'Messenger';
      case VIDABOO_CONSTANTS.CHAT_SUBTYPES.WHATSAPP_MESSAGE:
        return 'Whatsapp';
      case VIDABOO_CONSTANTS.CHAT_SUBTYPES.PHONE_MESSAGE:
        return 'Phone';
      case VIDABOO_CONSTANTS.CHAT_SUBTYPES.CUSTOM_LINK_MESSAGE:
        return 'Custom Link';
      default:
        return 'Video Chat';
    }
  };
  return (
    <>
      {eventType && (
        <div
          className={`et-chat-event-icon-container ${participantName ? 'et-ceic-with-name' : ''} ${handleClick ? 'et-ceic-with-click' : ''}`}>
          {participantName && (
            <ParticipantChatNameComponent participantName={participantName} />
          )}
          <div className="et-chat-event-icon-content" onClick={handleClick}>
            <div className="et-cci-img-wrap">{getIconFromEventType()}</div>
            <div className="et-cci-text">{getIconFromEventText()}</div>
          </div>
        </div>
      )}
      <div className="et-chat-status">
        <span className="et-time">{formattedDate}</span>
      </div>
    </>
  );
};

export default ChatEventIconComponent;
